import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import styled from 'styled-components';

const StyledBMProduct = styled.div`
  background-color: #eee;
  height: 60px;
  width: 100%;
  clear: both;
  display: table;
  position: relative;
  z-index: 6;
  border-radius: 8px;
  top: ${props => props.benchmark ? "-50px" : "0"}
  @media (min-width: 1024px) {
    top: ${props => props.benchmark ? "-30px" : "0"}
  }
  > div:first-of-type {
    width: 100%;
    background-color: #fff;
    display: table-cell;
    vertical-align: middle;
    position: relative;
    padding: 0 16px;
    z-index: 4;
    box-shadow: 0px 0px 10px 0 rgba(51, 51, 51, .1);
    border-radius: ${props => props.open ? "8px 0 0 0" : "8px 0 0 8px"};
    & > ul {
      margin: 0;
      list-style: none;
      overflow: hidden;
      height: auto;
      max-height: ${props => props.open ? "1000px" : 0};
      -webkit-transition: all .2s ease-in-out;
      -moz-transition: all .2s ease-in-out;
      -o-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out;
      position: absolute;
      background-color: #fff;
      left: 0;
      width: calc(100% + 60px);
      top: 60px;
      border-radius: 0 0 8px 8px;
      padding: ${props => props.open ? "20px 0" : 0};
      font-size: 0.825em;
      box-shadow: ${props => props.open ? "0px 3px 6px 3px rgba(0, 0, 0, .1)" : "0px 3px 6px 3px rgba(0, 0, 0, 0)"};
      li {
        color: #333;
        margin: 0;
        vertical-align: middle;
        padding: 8px 0 8px 48px;
        cursor: pointer;
        text-transform: uppercase;
        -webkit-transition: all .2s ease-in-out;
        -moz-transition: all .2s ease-in-out;
        -o-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;
      }
      li:hover {
        background: #eee;
      }
    }

    button {
      color: #333;
      z-index: 8;
      padding: 0;
      text-transform: uppercase;
      > i {
        margin: 0 14px 0 0;
        width: 14px;
        height: 14px;
        background-color: #555;
        padding: 3px;
        border-radius: 2px;
      }
    }

  }
  > div:last-of-type {
    background-color: #F4F4F4;
    display: table-cell;
    padding: 0 18px;
    position: relative;
    z-index: 1;
    box-shadow: 0px 0px 10px 0 rgba(51,51,51,0.10);
    border-radius: 0 8px 8px 0;
    > button {
      pointer-events: ${props => props.benchmark ? "all" : "none"};
      padding: 0;
      background: #fff;
      top: 30px;
      width: 24px;
      height: 24px;
      border-radius: 2px;
      margin: 0 auto;
      box-shadow: unset;
      transform: translateY(-50%);
      i {
        background: ${props => props.benchmark && props.benchmark.color ? "#333" : "#fff"};
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
        width: 14px;
        height: 14px;
        border-radius: 2px;
        border: 1px solid ${props => props.benchmark && props.benchmark.color ? "#333" : "#eee"};
        svg {
          width: 10px;
          height: 10px;
          margin: 1px auto 0 auto;
          g {
            stroke: none;
            fill: ${props => props.benchmark && props.benchmark.color ? "#fff" : "#bbb"};
          }
        }
      }
    }
  }
  > button {
    display: ${props => props.benchmark ? "inline-block" : "none"};
    font-size: .625em;
    height: 40px;
    border-radius: 5px;
    background: #333;
    box-shadow: 0 0 20px 5px rgba(0, 0, 0, .15);
    position: absolute;
    text-transform: uppercase;
    top: 70px;
    left: 0;
    width: 100%;
    i, span {
      float: left;
    }
    span {
      padding-top: 2px;
    }
    &::after {
      content: " ";
      box-shadow: inset 5px 0 5px 0 rgba(0, 0, 0, .2);
      position: absolute;
      top: 0;
      right: 0;
      height: 40px;
      position: absolute;
      width: 59px;
      z-index: 2;
    }
    > i:first-of-type svg {
      stroke: none;
      fill: #21A0D2;
    }
    > i:last-of-type {
      position: absolute;
      right: 12px;
      z-index: 3;
    }
  }
`;

export default function ProductBenchmark (props) {
  const {data, benchmark, setBenchmark, onMouseEnter, onMouseLeave, toggleColor, toggleLayer} = props;
  const [open, setOpen] = useState(false);

  return (
    <StyledBMProduct props={props} benchmark={benchmark} open={open} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div>
        <Button icon="down" label={benchmark ? benchmark.name : "Select benchmark?"} onClick={() => setOpen(!open)} transparent/>
        <ul>
        {data.filter(item => item !== benchmark).map((item, index) =>
          <li key={index} onClick={() => {setBenchmark(item); setOpen(false)}}>{item.name}</li>
        )}
        </ul>
      </div>
      <div>
        <Button icon="brush" onClick={toggleColor}/>
      </div>
      <Button icon="star" icon2="copy" label="Recommended Products" onClick={() => toggleLayer({bm: benchmark.name})} />
    </StyledBMProduct>
  )
}

ProductBenchmark.propTypes = {
  data: PropTypes.array
};
